export default class AdvertiseHeader {
  constructor() {
    if (this.vars()) {
      this.makeEqual();
      this.setupEvents();
    }
  }

  vars() {
    this.panel = document.querySelector(".ad-data-panel-js");
    this.sidebarPanel = document.querySelector(".user-avatar-js");

    if (!this.panel || !this.sidebarPanel) return false;

    this.breakpoint = 992;
    this.sidebarPadding = 30;

    return true;
  }

  setupEvents() {
    window.addEventListener("resize", () => {
      this.makeEqual();
      if (window.innerWidth < this.breakpoint) {
        this.sidebarPanel.style.height = "";
      }
    });
  }

  makeEqual() {
    if (window.innerWidth < this.breakpoint) return false;
    const panelHeight = this.panel.getBoundingClientRect().height;
    const targetHeight = panelHeight - this.sidebarPadding;
    this.sidebarPanel.style.height = `${targetHeight}px`;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/Components/AdvertiseHeader.js